import styled from "styled-components";

export const ErrorContainer = styled.div`
  display: grid;
  position: relative;
  width: 100%;
  max-width: ${(props) => props.width || "220px"};
`;
